"use strict";

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var isUndefined = function isUndefined(maybeUndefined) {
  return typeof maybeUndefined === 'undefined';
};
var isNull = function isNull(maybeNull) {
  return _typeof(maybeNull) === 'object' && !maybeNull;
};
var isString = function isString(maybeString) {
  return typeof maybeString === 'string';
};
var isObject = function isObject(maybeObject) {
  return _typeof(maybeObject) === 'object';
};
var baseDifference = function baseDifference(array, values, comparator) {
  var includes = Array.prototype.includes;
  var isCommon = true;
  var result = [];
  var valuesLength = values.length;
  if (!array.length) {
    return result;
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  var _iterator = _createForOfIteratorHelper(array),
    _step;
  try {
    outer: for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var value = _step.value;
      var computed = value;
      value = comparator || value !== 0 ? value : 0;
      if (isCommon && computed === computed) {
        var valuesIndex = valuesLength;
        while (valuesIndex--) {
          if (values[valuesIndex] === computed) {
            continue outer;
          }
        }
        result.push(value);
      } else if (!includes(values, computed, comparator)) {
        result.push(value);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return result;
};
var arrayIncludesWith = function arrayIncludesWith(array, target, comparator) {
  var _iterator2 = _createForOfIteratorHelper(array),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var value = _step2.value;
      if (comparator(target, value)) {
        return true;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return false;
};
module.exports = {
  notEmpty: function notEmpty(collection) {
    if (isUndefined(collection) || isNull(collection)) {
      return false;
    }
    if (Array.isArray(collection) || isString(collection)) {
      return !!collection.length;
    }
    if (isObject(collection)) {
      return !!Object.keys(collection).length;
    }
  },
  isFunction: function isFunction(maybeFunction) {
    return typeof maybeFunction === 'function';
  },
  differenceWith: function differenceWith(array, values, comparator) {
    return baseDifference(array, values, comparator);
  }
};
//# sourceMappingURL=kendash.js.map